/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConsumerWebhookHeadersInner } from './ConsumerWebhookHeadersInner';
import {
    ConsumerWebhookHeadersInnerFromJSON,
    ConsumerWebhookHeadersInnerFromJSONTyped,
    ConsumerWebhookHeadersInnerToJSON,
    ConsumerWebhookHeadersInnerToJSONTyped,
} from './ConsumerWebhookHeadersInner';

/**
 * Webhook configuration for the consumer.
 * @export
 * @interface ConsumerWebhook
 */
export interface ConsumerWebhook {
    /**
     * URL of the webhook.
     * @type {string}
     * @memberof ConsumerWebhook
     */
    url: string;
    /**
     * HTTP method to use for the webhook.
     * @type {string}
     * @memberof ConsumerWebhook
     */
    method?: ConsumerWebhookMethodEnum;
    /**
     * 
     * @type {Array<ConsumerWebhookHeadersInner>}
     * @memberof ConsumerWebhook
     */
    headers?: Array<ConsumerWebhookHeadersInner>;
    /**
     * 
     * @type {Array<ConsumerWebhookHeadersInner>}
     * @memberof ConsumerWebhook
     */
    _queryParameters?: Array<ConsumerWebhookHeadersInner>;
}


/**
 * @export
 */
export const ConsumerWebhookMethodEnum = {
    Post: 'POST'
} as const;
export type ConsumerWebhookMethodEnum = typeof ConsumerWebhookMethodEnum[keyof typeof ConsumerWebhookMethodEnum];


/**
 * Check if a given object implements the ConsumerWebhook interface.
 */
export function instanceOfConsumerWebhook(value: object): value is ConsumerWebhook {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function ConsumerWebhookFromJSON(json: any): ConsumerWebhook {
    return ConsumerWebhookFromJSONTyped(json, false);
}

export function ConsumerWebhookFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsumerWebhook {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'method': json['method'] == null ? undefined : json['method'],
        'headers': json['headers'] == null ? undefined : ((json['headers'] as Array<any>).map(ConsumerWebhookHeadersInnerFromJSON)),
        '_queryParameters': json['queryParameters'] == null ? undefined : ((json['queryParameters'] as Array<any>).map(ConsumerWebhookHeadersInnerFromJSON)),
    };
}

export function ConsumerWebhookToJSON(json: any): ConsumerWebhook {
    return ConsumerWebhookToJSONTyped(json, false);
}

export function ConsumerWebhookToJSONTyped(value?: ConsumerWebhook | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'method': value['method'],
        'headers': value['headers'] == null ? undefined : ((value['headers'] as Array<any>).map(ConsumerWebhookHeadersInnerToJSON)),
        'queryParameters': value['_queryParameters'] == null ? undefined : ((value['_queryParameters'] as Array<any>).map(ConsumerWebhookHeadersInnerToJSON)),
    };
}

